import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  Input,
} from '@angular/core';
import { mapValues } from '@sama/micro-dash';
import { DebouncedEventTracker } from '../../../../../cross-team-shared/event-tracking/debounced-event-tracker';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';

@Component({
  selector: 'h3-sensor-color-option',
  templateUrl: './sensor-color-option.component.html',
  styleUrl: './sensor-color-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SensorColorOptionComponent {
  @Input({ required: true }) sourceId!: number;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) sensorSelectionTracker!: DebouncedEventTracker;

  private settingsStore = inject(settingsStoreToken)('layerSettings3d');

  @HostListener('mouseover')
  highlightSensor() {
    this.settingsStore('highlightedSensor').set(this.sourceId);
  }

  @HostListener('mouseleave')
  removeSensorHighlight() {
    this.settingsStore('highlightedSensor').set(-1);
  }

  setPointVisibilityForSensor(visible: boolean) {
    this.settingsStore('pointAppearanceBySensor')(this.sourceId).setUsing(
      (rbga) => [rbga[0], rbga[1], rbga[2], visible ? 255 : 0],
    );

    const { pointAppearanceBySensor } = this.settingsStore.state();

    this.sensorSelectionTracker.trackWithDebounce({
      point_visibility_by_sensor: mapValues(
        pointAppearanceBySensor,
        (rgba) => rgba[3] !== 0,
      ),
    });
  }

  getPointVisibilityForSensor() {
    return (
      this.settingsStore.state().pointAppearanceBySensor[this.sourceId][3] !== 0
    );
  }

  getRgbStringForSensor() {
    const [r, g, b] =
      this.settingsStore.state().pointAppearanceBySensor[this.sourceId];
    return `rgb(${r}, ${g}, ${b})`;
  }
}
